import React from 'react'

const FooterBottom = () => {
  return (
    <>
      <div className="bg-[#212428] px-5 py-6">
        <div className="max-w-[100rem] mx-auto">
          <div className="border-t-[1px] border-[#ff014f]  my-24"></div>

          <span className=" text-white flex justify-center text-lg items-center">
            © 2023. All rights reserved by Sudeep Bhandari
          </span>
        </div>
      </div>
    </>
  )
}

export default FooterBottom
